import actionTypes from '../constants/action-types';

const serviceConfig = (state = null, action) => {
  if (action.type !== actionTypes.SET_SERVICE_CONFIG) return state;
  return action.payload.config;
};

export default serviceConfig;
